import { useState } from "react";
import Sidebar from "../components/projects/Sidebar";
import ProjectsGrid from "../components/projects/ProjectsGrid";
import Drawer from "../components/common/Drawer";
import ProjectHeader from "../components/projects/ProjectHeader";

export default function Projects() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <main className="h-screen overflow-hidden grid grid-cols-1 md:grid-cols-[159px_1fr] backdrop-blur-[100px] bg-[#262D48A6] project-bg bg-cover">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col flex-1">
        <Sidebar />
      </aside>

      {/* Main Content Area */}
      <div className="flex flex-col gap- 2xl:gap-[50px] sm:gap-8 flex-1 overflow-auto relative z-[2]">
        {/* Header Section */}
        <ProjectHeader
          setIsDrawerOpen={setIsDrawerOpen}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />

        {/* Projects Content */}
        <section className="flex-1  px-5 sm:px-10 xl:px-20 pb-10">
          <ProjectsGrid searchQuery={searchQuery} />
        </section>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        position="left"
      >
        <Sidebar onItemClick={() => setIsDrawerOpen(false)} />
      </Drawer>
    </main>
  );
}
